import React from 'react';
import {InstagramOutlined,ContactsOutlined,CodepenOutlined, UnorderedListOutlined } from '@ant-design/icons';


export const DashboardData =[
    {title:'Events',Icon:<UnorderedListOutlined />,value:'296',background:'#dd4b39',url:'/events' },
    {title:'Sessions',Icon:<CodepenOutlined />,value:'307',background:'#0073b7',url:'/sessions' },
    {title:'Users',Icon:<ContactsOutlined />,value:'7',background:'#00a65a',url:'/users' },
    {title:'Machines',Icon:<InstagramOutlined />,value:'6',background:'#00c0ef',url:'/machines' },
    {title:'Countries',Icon:<InstagramOutlined />,value:'6',background:'#00c0ef',url:'/countries' },
    {title:'Companies',Icon:<InstagramOutlined />,value:'6',background:'#00c0ef',url:'/companies' },
    {title:'Configurations',Icon:<InstagramOutlined />,value:'6',background:'#00c0ef',url:'/configurations' },
    
]